{
  "play": "Play",
  "pause": "Pause",
  "mute": "Mute",
  "unmute": "Unmute"
}
